<template>
    <ReceiptContainer>
        <ChargeSummary :invoice='invoice'/>
    </ReceiptContainer>
</template>

<script>
import ReceiptContainer from '@/components/global/ReceiptContainer.vue';
import ChargeSummary from '@/components/rent/shared/chargeSummary/ChargeSummary.vue';
import { mapState, mapGetters } from 'vuex';

export default {
    components: {
        ReceiptContainer,
        ChargeSummary
    },
    computed: {
        ...mapGetters('newRental', [
            'rentalPrice',
            'serviceFee',
            'deliveryFee',
            'subtotal',
            'total'
        ]),
        ...mapState('newRental', ['listingData', 'loadingReceiptData']),
        invoice() {
            return {
                fees: [
                    {
                        heading: 'Rental Price',
                        description: '',
                        price: this.rentalPrice
                    },
                    ...this.listingData.fees.map(fee => {
                        return {
                            heading: fee.name,
                            description: fee.description,
                            price: parseFloat(fee.amount)
                        };
                    }),
                    {
                        heading: 'Delivery',
                        description: 'delivery charge...',
                        price: this.deliveryFee
                    },
                    {
                        heading: 'Tooliaba Service Fee & Taxes',
                        description: 'tooliaba service fee...',
                        price: this.serviceFee
                    }
                ],
                refundableFees: [
                    {
                        heading: 'Refundable Deposit',
                        description: 'refundable deposit....',
                        price: parseFloat(this.listingData.deposit)
                    }
                ]
            };
        }
    }
};
</script>
